export default function CapacityIndicator({ capacity, totalRSVPs, spotsAvailable }) {
  const percent = (totalRSVPs / capacity) * 100;
  const isNearlyFull = percent >= 90;
  const isFull = spotsAvailable === 0;

  return (
    <div className="bg-white rounded-2xl p-6 shadow-soft border border-[#E1DFD7] mb-6" data-testid="capacity-indicator">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-medium text-[#0B2240]">Event Capacity</h3>
        <span className="text-sm text-[#4C5A70]">
          {totalRSVPs} / {capacity} registered
        </span>
      </div>

      {/* Progress Bar */}
      <div className="h-3 bg-[#EDEBE6] rounded-full overflow-hidden mb-3">
        <div
          className={`h-full rounded-full transition-all duration-500 ${
            isFull ? 'bg-[#C7362E]' : isNearlyFull ? 'bg-[#D4AF37]' : 'bg-gradient-to-r from-[#0B2240] to-[#1FA3A3]'
          }`}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>

      {/* Status Message */}
      {isNearlyFull && spotsAvailable > 0 && (
        <p className="text-sm text-[#D4AF37] font-medium">
          ⚠️ Only {spotsAvailable} spots left!
        </p>
      )}

      {isFull && (
        <p className="text-sm text-[#C7362E] font-medium">
          Event at capacity - Waitlist available
        </p>
      )}

      {!isNearlyFull && (
        <p className="text-sm text-[#1FA3A3] font-medium">
          ✓ {spotsAvailable} spots available
        </p>
      )}
    </div>
  );
}
